export const AuthTypes = {
  signIn: "[Auth] SignIn",
  signOut: "[Auth] SignOut",
  nameChanged: "[Auth] NameChanged",
  updateInfo: "[Auth] Update Info",
  error: "[Auth] Error",
};
